import { StatisticsStore, statisticsStore } from './StatisticsStore';
import { StatisticsPeriod } from '../types';
import { api } from '../../api';
import { AbstractFacade } from '../../shared';

export class StatisticsFacade extends AbstractFacade {
  constructor(readonly store: StatisticsStore) {
    super(store);
  }

  loadByPeriod = (websiteId: string, period: StatisticsPeriod) =>
    this.doRequest(async () => {
      const res = await api.statistics.load(websiteId, period);

      if (res.response) {
        this.store.update((state) => {
          state.statistics = res.response;
        });
      }
    });

  setPeriod(period: StatisticsPeriod) {
    this.store.update((state) => {
      state.period = period;
    });
  }
}

export const facade = new StatisticsFacade(statisticsStore);
